import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
  hasCircle?: boolean
}

export function AppIconProfileRounded({ size = 20, color, hasCircle = true }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  if (!hasCircle) {
    return (
      <Svg width={size} height={size} viewBox="0 0 40 40" fill="none">
        <Path
          fill={fill}
          transform="translate(12.5 10.13)"
          d="M7.5 0C3.35787 0 0 3.35787 0 7.5C0 11.6421 3.35787 15 7.5 15C11.6422 15 15 11.6421 15 7.5C15 3.35787 11.6422 0 7.5 0Z"
        />
        <Path
          fill={fill}
          transform="translate(5 28.128)"
          d="M15 0C7.2793 0 1.62586 4.80617 0.0870463 11.1607C-0.433356 13.3097 1.46515 15 3.50371 15H26.4963C28.535 15 30.4334 13.3097 29.9129 11.1607C28.3743 4.80617 22.7207 0 15 0Z"
        />
      </Svg>
    )
  }

  return (
    <Svg width={size} height={size} viewBox="1.87793 1.87793 20.24397 20.24397" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
        d="M11.9999 1.87793C17.5907 1.87793 22.1219 6.40972 22.1219 11.9999C22.1219 17.5901 17.5907 22.1219 11.9999 22.1219C6.4091 22.1219 1.87793 17.5901 1.87793 11.9999C1.87793 6.40972 6.4091 1.87793 11.9999 1.87793ZM11.9999 15.0365C9.57619 15.0365 7.56365 16.0543 6.21537 17.6678C7.6862 19.1673 9.73447 20.0975 11.9999 20.0975C14.2654 20.0975 16.3136 19.1673 17.7845 17.6678C16.4362 16.0543 14.4236 15.0365 11.9999 15.0365ZM11.9999 6.68588C10.1825 6.68588 8.71028 8.15872 8.71028 9.97553C8.71028 11.7923 10.1825 13.2652 11.9999 13.2652C13.8173 13.2652 15.2896 11.7923 15.2896 9.97553C15.2896 8.15872 13.8173 6.68588 11.9999 6.68588Z"
      />
    </Svg>
  )
}
